<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'games.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <div class="game-container-sections">
    <div class="cursor-pointer" [routerLink]="'/games/trivia'">
      <img *notInPopulation="[population.Kids]" src="assets/images/games/trivia-thumnail.png" />
      <img class="kids-trivia-img" *inPopulation="[population.Kids]" src="assets/images/kids/kids-trivia.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14 text-white">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div>
          <div class="btn btn-secondary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>
    <ng-container *notInPopulation="[population.Kids]">
      <div class="cursor-pointer" [routerLink]="'/games/predictor'">
        <img src="assets/images/games/predictor-thumnail.jpg" />
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.predictor' | translate }}</h5>
            <div class="font-size-14 text-white">{{ 'games.page.predictor.description' | translate }}</div>
          </div>
          <div>
            <div class="btn btn-primary">{{ 'games.page.predictor.play' | translate }}</div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *inPopulation="[population.Kids]">
      <div class="game-container-sections">
        <div class="cursor-pointer" [routerLink]="'/games/polls'">
          <img class="kids-polls-img" src="assets/images/kids/kids-polls.jpg" />
          <div class="card">
            <div class="">
              <h5>{{ 'games.page.polls' | translate }}</h5>
              <div class="font-size-14 text-white">{{ 'games.page.polls.description' | translate }}</div>
            </div>
            <div>
              <div class="btn btn-secondary">{{ 'games.page.polls.play' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *notInPopulation="[population.Kids]">
    <div class="game-container-sections mt-4">
      <div class="cursor-pointer" [routerLink]="'/games/polls'">
        <img src="assets/images/games/polls-thumnail.jpg" />
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.polls' | translate }}</h5>
            <div class="font-size-14 text-white">{{ 'games.page.polls.description' | translate }}</div>
          </div>
          <div>
            <div class="btn btn-secondary">{{ 'games.page.polls.play' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
